/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type {
  RevokeAPIKeyForUserIntegratorOptions,
  RevokeAPIKeyForUserIntegratorResponses,
} from '../types/RevokeAPIKeyForUserIntegrator'
import { client, withUnwrap } from '../.kubb/client'

/**
 * @summary Revoke apikey for a user: admin or integrator only
 * {@link /v1/user/:user_id/apikey/:key_id/revoke}
 */
export function revokeAPIKeyForUserIntegrator<ThrowOnError extends boolean = true>(
  options: Options<RevokeAPIKeyForUserIntegratorOptions, ThrowOnError>,
): Unwrappable<RequestResult<RevokeAPIKeyForUserIntegratorResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(
    request({
      method: 'PUT',
      url: '/v1/user/{user_id}/apikey/{key_id}/revoke',
      security: [
        { type: 'http', scheme: 'bearer' },
        { type: 'apiKey', name: 'Authorization', in: 'header' },
      ],
      ...config,
      throwOnError: config.throwOnError ?? true,
    }) as Promise<RequestResult<RevokeAPIKeyForUserIntegratorResponses, ThrowOnError>>,
  )
}
